module.exports = __webpack_public_path__ + "media/images/countrysquared/cc-9e5438c5d58f21e27fb8678f31d47925.svg";